import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import UserContext from "../../store/auth-context";

/**
 * Piano Page Tracker Component for SPA
 * 
 * This component:
 * - Tracks route changes and notifies Piano
 * - Executes Piano experience on every route change
 * - Updates user context when Piano is ready
 * 
 * Piano script is loaded ONCE in public/index.html
 */
const Piano = () => {
  const location = useLocation();
  const [pianoReady, setPianoReady] = useState(false);
  const userCTX = useContext(UserContext);

  // Check if Piano is ready and initialize
  useEffect(() => {
    const checkPianoReady = () => {
      if (window.tp && typeof window.tp.push === "function") {
        setPianoReady(true);
        return true;
      }
      return false;
    };

    // Try immediately
    if (checkPianoReady()) return;

    // If not ready, poll every 100ms (max 5 seconds)
    const interval = setInterval(() => {
      if (checkPianoReady()) {
        clearInterval(interval);
      }
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      console.warn("Piano script not loaded after 5 seconds");
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  // Track route changes and execute Piano experience
  useEffect(() => {
    if (!pianoReady || !window.tp) return;

    // Set current path as tag
    window.tp.push([
      "setTags",
      {
        path: location.pathname,
      },
    ]);

    // Execute Piano experience (paywall, offers, etc.)
    window.tp.push(["experience.execute"]);
  }, [location.pathname, pianoReady]);

  // Update user context when Piano is ready
  useEffect(() => {
    if (pianoReady && userCTX.getPianoUser) {
      userCTX.getPianoUser();
    }
  }, [pianoReady, userCTX]);

  return null;
};

export default Piano;
